export default "__VITE_ASSET__f1e347f8__"